import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoursesService } from 'src/app/services/courses.service';
import { QuizService } from 'src/app/services/quiz.service';
import { PDFDocument } from 'pdf-lib'
import { FileHelper } from 'src/app/helpers';
import { QuizQuestion } from 'src/app/models';

@Component({
  selector: 'app-module4-rw',
  templateUrl: './module4-rw.component.html',
  styleUrls: ['./module4-rw.component.css', '../rentwise.component.css']
})
export class Module4RwComponent implements OnInit {

  module = 4;
  page = 1;
  // Variable to signal quiz start

  srcHandout: string = "../../../../../assets/RWM4A5Handout.pdf";
  pdfHandout!: PDFDocument;

  sampleCreditLetter: string = "../../../../../assets/sampleCreditLetter.pdf";
  letterHandout!: PDFDocument;

  sampleCreditReportOrder: string = "../../../../../assets/sampleCreditReportOrder.pdf";
  orderHandout!: PDFDocument;


  // When this value is false the answer will be revealed for activity five.
  page22_qclick = new Array(16).fill(true);

  // Contains all questions for the module
  questions: QuizQuestion[] = [];

  constructor(private courseService: CoursesService, private router: Router, private quizService: QuizService) { }

  async ngOnInit(): Promise<void> {
    this.courseService.setCurrentCourseBy('RentWise');

    // Open the furthest page
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      this.page = this.courseService.currentCourse.furthestPageID + 1;
    }

    // Get the questions for this module and assign them to this.questions
    this.quizService.getModuleQuizzes("61f3439afadf713839b08cdc").toPromise().then((res: any) => {
      this.quizService.moduleQuizQuestions = res.docs;
      this.questions = this.quizService.moduleQuizQuestions;
    });

    const handoutFillablePdfBytes = await fetch("../../../../../assets/RWM4A5Handout.pdf").then(res => res.arrayBuffer());
    this.pdfHandout = await PDFDocument.load(handoutFillablePdfBytes);

    const letterBytes = await fetch("../../../../../assets/sampleCreditLetter.pdf").then(res => res.arrayBuffer());
    this.letterHandout = await PDFDocument.load(letterBytes);

    const orderBytes = await fetch("../../../../../assets/sampleCreditLetter.pdf").then(res => res.arrayBuffer());
    this.orderHandout = await PDFDocument.load(orderBytes);

  }

  // Update furthestModuleID
  updateProgress() {
    if (this.courseService.currentCourse.furthestModuleID < this.module) {
      this.courseService.updateFurthestModule().toPromise().then((res: any) => {
        console.log(res);
      });
    }
  }

  // Update furthestPageID
  updatePageProgress() {
    if (this.courseService.currentCourse.furthestModuleID === this.module - 1) {
      if (this.courseService.currentCourse.furthestPageID < this.page) {
        this.courseService.updateFurthestPage(this.page).toPromise();
      }
    }
  }

  // Handle the quiz results, allow them to pass or not
  handleQuiz(valueEmitted: boolean){

    // Quiz passed
    if (valueEmitted) {
      this.updateProgress();
      this.router.navigate(['/module5-rw']);
    }

    // Review
    else {
      this.page = 1
    }
  }

  next(event?: Event) {
    if (event?.defaultPrevented) return false;
    this.page += 1;
    window.scrollTo(0,0);
    this.updatePageProgress();
    return true;
  }

  back(){
    this.page -= 1;
    window.scrollTo(0,0);
    return true;
  }

  async downloadActivityFive() {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.pdfHandout.save();
    FileHelper.saveByteArray('RWM4A5Handout.pdf', pdfBytes, 'application/pdf');
  }

  async downloadLetter() {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.letterHandout.save();
    FileHelper.saveByteArray('sampleCreditLetter.pdf', pdfBytes, 'application/pdf');
  }

  async downloadOrder() {
    // Serialize the PDFDocument to bytes (a Uint8Array) for download
    const pdfBytes = await this.orderHandout.save();
    FileHelper.saveByteArray('sampleCreditReportOrder.pdf', pdfBytes, 'application/pdf');
  }

  all<T = unknown>(array: T[], value: T) {
    return array.every(v => v === value);
  }

  allOf(obj: Object, value = true) {
    return this.all(Object.values(obj), value);
  }
}
